import React from "react";
import { View, Image, ScrollView } from "react-native";
import { ModalM } from "@common/components/modal/ModalM";
import TitleM from "@common/components/text/TitleM";
import TextM from "@common/components/text/TextM";
import { theme } from "@common/theme/theme";
import FontAwesome5 from "react-native-vector-icons/FontAwesome5";
import micMutePc from "@assets/mic-mute-pc.jpeg";
import { usePermissions } from "@common/livekit/components/PermissionBanner";
import MicrophoneLevelBars from "./MicrophoneLevelBars";
import { useMicrophoneLevel } from "../../../engine/precall/useMicrophoneLevel";

/**
 * Help modal showing troubleshooting tips for microphone issues
 * Displays visual guide with keyboard mute button
 */
const MicrophoneHelpModal = ({ visible, onDismiss, isSoundMode }) => {
    const { permissionsGranted } = usePermissions();
    const micLevel = useMicrophoneLevel(visible ? permissionsGranted : null);

    const renderTip = (icon, text) => (
        <View
            style={{
                flexDirection: "row",
                alignItems: "flex-start",
                marginBottom: 15,
                paddingHorizontal: 10,
            }}
        >
            <FontAwesome5
                name={icon}
                size={18}
                color={theme.colors.primary}
                style={{ marginRight: 12, marginTop: 2 }}
            />
            <TextM style={{ flex: 1 }} wrap>
                {text}
            </TextM>
        </View>
    );

    return (
        <ModalM
            visible={visible}
            onDismiss={onDismiss}
            dismissable={true}
            withExitButton={true}
            style={{
                maxHeight: "85%",
                padding: 20,
                alignItems: "center",
                width: "90%",
                maxWidth: 500,
            }}
        >
            <ScrollView
                style={{ width: "100%" }}
                contentContainerStyle={{ paddingBottom: 20 }}
                showsVerticalScrollIndicator={false}
            >
                <TitleM style={{ marginBottom: 20, textAlign: "center" }}>
                    On ne t'entend pas ? 🎤
                </TitleM>

                {/* Test micro dans le modal */}
                <View
                    style={{
                        backgroundColor: theme.colors.lighter,
                        padding: 15,
                        borderRadius: 10,
                        marginBottom: 20,
                        marginHorizontal: 10,
                    }}
                >
                    <TextM
                        fontWeight="SemiBold"
                        fontSize={13}
                        style={{ marginBottom: 10, textAlign: "center" }}
                    >
                        Teste ton micro :
                    </TextM>
                    <View style={{ alignSelf: "center" }}>
                        <MicrophoneLevelBars micLevel={micLevel} />
                    </View>
                    <TextM
                        fontSize={11}
                        color={theme.colors.grey}
                        style={{ marginTop: 10, textAlign: "center" }}
                    >
                        Si les points s'allument quand tu parles, ton micro fonctionne !
                    </TextM>
                </View>

                {/* Warning mode concentré */}
                {isSoundMode === false && (
                    <View
                        style={{
                            backgroundColor: theme.colors.purple,
                            padding: 15,
                            borderRadius: 10,
                            marginBottom: 20,
                            marginHorizontal: 10,
                        }}
                    >
                        <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 8 }}>
                            <FontAwesome5
                                name="volume-mute"
                                size={16}
                                color={theme.colors.white}
                                style={{ marginRight: 8 }}
                            />
                            <TextM
                                color={theme.colors.white}
                                fontWeight="SemiBold"
                                fontSize={13}
                            >
                                Mode concentré activé
                            </TextM>
                        </View>
                        <TextM
                            color={theme.colors.white}
                            fontSize={12}
                            wrap
                        >
                            Ton audio est coupé. Seul ton tuteur peut te remettre en mode dialogue pour que vous puissiez vous entendre.
                        </TextM>
                    </View>
                )}

                <TextM
                    fontWeight="SemiBold"
                    fontSize={14}
                    style={{ marginBottom: 15, paddingHorizontal: 10 }}
                >
                    Vérifie ces points :
                </TextM>

                {renderTip(
                    "volume-up",
                    "Vérifie que le son de ton appareil n'est pas à zéro (ordinateur ou casque)."
                )}

                {renderTip(
                    "keyboard",
                    "Certains claviers ont une touche qui coupe le micro. Vérifie l'image ci-dessous."
                )}

                {/* Image montrant le bouton mute du clavier */}
                <View
                    style={{
                        backgroundColor: theme.colors.lighter,
                        padding: 10,
                        borderRadius: 10,
                        marginBottom: 15,
                        marginHorizontal: 10,
                    }}
                >
                    <Image
                        source={micMutePc}
                        style={{
                            width: "100%",
                            height: 120,
                            borderRadius: 8,
                        }}
                        resizeMode="contain"
                    />
                    <TextM
                        fontSize={11}
                        color={theme.colors.grey}
                        style={{ marginTop: 8, textAlign: "center" }}
                    >
                        Exemple de touche micro (si ton clavier en a une)
                    </TextM>
                </View>

                {renderTip(
                    "desktop",
                    "Vérifie les paramètres système de ton ordinateur : le micro est-il autorisé et activé ?"
                )}

                {renderTip(
                    "chrome",
                    "Le navigateur peut bloquer le micro. Clique sur l'icône à gauche de l'URL (micro/caméra ou barres) et autorise le micro."
                )}
            </ScrollView>
        </ModalM>
    );
};

export default MicrophoneHelpModal;
